export const randomProperty = function (properties: string[]) {
  return properties[(properties.length * Math.random()) << 0];
};
